import * as API from '../utilities/api';
import { stopLoad } from './loading';
import { receiveLocations } from './bookingLocation';

export const RESET_APP = 'RESET_APP';
export const RESET_CART = 'RESET_CART';

// 1. Enable loading overlay
// 2. Fetch up to date location info
// 3. Reset the app to a blank state
// 4. Receive the location info into the state
// This should probably only go back to the station selection screen
// but this is safer and simpler
export function tryResetApp() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      // dispatch(startLoad());
      API.getLocations()
        .then((result) => {
          dispatch(resetApp());
          dispatch(receiveLocations(result));
          // dispatch(stopLoad());
          resolve();
        })
        .catch((error) => {
          dispatch(stopLoad());
          console.error('Failed to get locations info: ' + error);
          reject(error);
        });
    });
  };
}

export function resetApp() {
  return {
    type: RESET_APP
  };
}

export function resetCart() {
  return {
    type: RESET_CART
  };
}
